var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recharge_page"},[_c('h1',[_vm._v("Welcome to chenxi's App")]),_c('p',[_vm._v("This is the Recharge Page of llmbot.")])])
}]

export { render, staticRenderFns }